<template>
  <b-overlay :show="showOverlay" rounded="sm">
    <b-card
      bg-variant="light"
      text-variant="dark"
      border-variant="success"
      class="text-left px-1"
    >
      <b-card-text>
        <b-form-group
          id="label-account-email"
          label-cols-sm="6"
          label-cols-lg="4"
          label-for="register-account-email"
          label="Email Address"
        >
          <b-form-input
            id="register-account-email"
            v-model="username"
            disabled
          ></b-form-input>
        </b-form-group>

        <div class="mb-2">
          <strong>
            Find the following information from your ND Energy invoice.</strong
          >
        </div>

        <b-form-group
          id="label-account-num"
          label-cols-sm="6"
          label-cols-lg="4"
          label-for="register-account-num"
          label="Account Number"
        >
          <b-form-input
            id="register-account-num"
            v-model="account_num"
            placeholder="100100203004"
            type="text"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="label-access-code"
          label-cols-sm="6"
          label-cols-lg="4"
          label-for="register-access_code"
          label="Access Code"
        >
          <b-form-input
            id="register-access_code"
            v-model="access_code"
            placeholder="ab682f91"
            type="text"
            required
          ></b-form-input>
        </b-form-group>
      </b-card-text>

      <b-button variant="secondary" class="mr-2" @click="cancelAddAccount"
        >Cancel</b-button
      >

      <b-button variant="danger" @click="execAddAccount"
        >Register Account</b-button
      >
    </b-card>
  </b-overlay>
</template>

<script>
import { regPortalUserAccount } from '@services'

export default {
  props: {
    username: { type: [String], required: false, default: null },
  },

  data() {
    return {
      showOverlay: false,
      // account_num: '100200414001',
      // access_code: 'a8211e0d',
      account_num: '',
      access_code: '',
      regResultMessage: '',
    }
  },

  methods: {
    async execAddAccount() {
      this.showOverlay = true
      this.regResultMessage = ''

      const result = await regPortalUserAccount({
        registeraccount: {
          username: this.username,
          account_num: this.account_num,
          access_code: this.access_code,
        },
      })

      if (result.status === 'Success') {
        this.showOverlay = false
        // this.$store.state.auth.account_list = result.data

        this.regResultMessage = result.message
        this.$emit('successAddAccount')
      }
    },

    cancelAddAccount() {
      // console.log('cancelAddAccount executed.')
      this.$emit('cancelAddAccount')
    },
  },
}
</script>
